import React from "react";
import styles from "./RatingStars.module.scss";
import {useTranslation} from "react-i18next";

type RatingStarsProps = {
  rating: number;
  size?: "small" | "medium" | "large";
  customSize?: number;
  color?: "green" | "blue" | "darkgrey";
  metaProp?: boolean;
};

const RatingStars: React.FC<RatingStarsProps> = ({
  rating,
  size = "medium",
  customSize,
  color = "darkgrey",
  metaProp = true,
}) => {
  const {t} = useTranslation();
  const ratingProcessed = Math.round(rating > 10 ? 10 : rating);
  const FilledStarsCount = (ratingProcessed - (ratingProcessed % 2)) / 2;
  const EmptyStarsCount = 5 - FilledStarsCount - (ratingProcessed % 2);
  const isHalfStar = ratingProcessed % 2 === 1;
  const ratingForTitle = new Intl.NumberFormat([], {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(
    rating / 2,
  );

  return (
    <div
      itemProp={metaProp ? "reviewRating" : undefined}
      itemType={metaProp ? "https://schema.org/Rating" : undefined}
      className={styles.wrapper}
      title={t("rating.starRating--rating", {
        rating: ratingForTitle,
      })}
    >
      {metaProp && <meta itemProp="ratingValue" content={ratingProcessed.toString()} />}
      {Array.from({length: FilledStarsCount}, (_, index) => {
        const classConcat = [styles.starIcon, styles[size]].join(" ");

        return (
          <div
            key={`filled${index}`}
            style={customSize ? {width: customSize, height: customSize} : undefined}
            className={classConcat}
          >
            <i className={`icon-star--${color} ${styles.star}`} />
          </div>
        );
      })}
      {isHalfStar && (
        <div
          style={customSize ? {width: customSize, height: customSize} : undefined}
          className={[styles.starIcon, styles[size]].join(" ")}
        >
          <i className={`icon-halfstar--${color} ${styles.star}`} />
        </div>
      )}
      {Array.from({length: EmptyStarsCount}, (_, index) => {
        const classConcat = [styles.starIcon, styles[size]].join(" ");

        return (
          <div
            key={index}
            style={customSize ? {width: customSize, height: customSize} : undefined}
            className={classConcat}
          >
            <i className={`icon-star ${styles.star}`} />
          </div>
        );
      })}
    </div>
  );
};

export default RatingStars;
